import { ErrorHandler, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
/**
 * Handles errors that bubble all the way up
 */
export class UnexpectedErrorHandler implements ErrorHandler {
  unexpectedError = 'unexpected-error';

  /**
   * @constructor
   * @param {TranslocoService} transloco
   */
  constructor(transloco: TranslocoService) {
    transloco.selectTranslate(this.unexpectedError).subscribe((translation) => {
      this.unexpectedError = translation;
    });
  }

  /**
   * Pops up a snack bar informing of an unexpected error
   * @param {Error} error
   */
  handleError(error: Error) {
    if (environment.consoleLogErrors) {
      // eslint-disable-next-line
      console.error(error);
    }
  }
}
